import React from 'react';

import type { ButtonProps } from './types';
import { useButton } from './use-button';

import { Icon } from '../icon';
import { Spinner } from '../progress';

export const Button = ({ ref, ...props }: ButtonProps) => {
  const {
    createRipple,
    tag,
    type,
    IconLeft,
    IconRight,
    buttonStyles,
    iconLeftStyles,
    iconRightStyles,
    showLoader,
    disabled,
    children,
    loaderSize,
    other,
  } = useButton(props);

  return React.createElement(
    tag,
    {
      className: buttonStyles,
      ref,
      disabled,
      type,
      onMouseDown: (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent> & React.MouseEvent<HTMLAnchorElement, MouseEvent>
      ) => {
        createRipple(e as unknown as MouseEvent);
        return typeof other.onMouseDown === 'function' && other.onMouseDown(e);
      },
      ...other,
    },
    IconLeft ? <Icon className={iconLeftStyles} icon={IconLeft} /> : null,
    children || null,
    IconRight ? <Icon className={iconRightStyles} icon={IconRight} /> : null,
    showLoader ? (
      <div className="absolute inset-0 z-10 flex items-center justify-center" aria-hidden={true}>
        <Spinner size={loaderSize} />
      </div>
    ) : null
  );
};
